module.exports = __webpack_public_path__ + "static/introduction-intro-no_text-b929f1eb14b0c45e8688f0c11ef6b071.mp4";